export const renameObjectKeys = (arrayObj, oldValueKey, oldNameKey) => {
  const newFormat = arrayObj?.map((array) => {
    return {
      value: array[oldValueKey],
      name: array[oldNameKey]
    }
  })
  return newFormat
}